import React, { useState } from 'react';
import { cva } from 'class-variance-authority';
import ErrorMessage from '@/components/common/ErrorMessage';
import { cn } from '@/lib/utils';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const inputDatepickerVariants = cva('flex w-full rounded-lg border border-[#D9DBE9] text-secondary outline-0 disabled:cursor-not-allowed disabled:opacity-50', {
    variants: {
        variant: {
            default: '',
            outline: '',
        },
        size: {
            default: 'h-12',
            sm: 'h-10 rounded-md text-sm',
            lg: 'h-11 rounded-md text-base',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
});

const InputDatepicker = React.forwardRef(
    (
        {
            className,
            groupClassName,
            size,
            variant,
            type,
            prefixIcon,
            prefixWrap,
            iconClassName,
            suffixWrap,
            suffixIcon,
            inputClassName,
            labelClassName,
            labelStyleClassName,
            labelText,
            id,
            error,
            ...props
        },
        ref
    ) => {
        return (
            <div className={cn('form-input-item', groupClassName)}>
                {labelText && (
                    <label htmlFor={id} className={cn(labelStyleClassName ? labelStyleClassName : 'text-sm text-foreground inline-block mb-1.5', labelClassName)}>
                        {labelText}
                    </label>
                )}
                <div className={cn(inputDatepickerVariants({ size, className, variant }), '[&>.react-datepicker-wrapper]:px-4')}>
                    {prefixWrap ? prefixWrap : prefixIcon && <span className={cn('block flex-shrink-0', iconClassName)}>{prefixIcon}</span>}
                    {/* <input type={type} id={id} ref={ref} className={cn('outline-0 bg-transparent border-0 w-full h-full', inputClassName)} {...props} /> */}
                    <DatePicker className="w-full h-full block" {...props} />
                    {suffixWrap ? suffixWrap : suffixIcon && <span className={cn('block flex-shrink-0', iconClassName)}>{suffixIcon}</span>}
                </div>
                {error && <ErrorMessage errorData={error} />}
            </div>
        );
    }
);

export { InputDatepicker };
